import { useTranslation } from "react-i18next";
import { useGoogleLogin } from "@react-oauth/google";
import googleSvg from "@/assets/img/icons/google.svg";
import { cosent, login } from "@/services/auth";
import { useAuthContext } from "@/context/AuthContext";

interface GoogleAuthProps {
  mode: "register" | "login";
  referralCode?: string;
}

export function GoogleAuth({ mode, referralCode }: GoogleAuthProps) {
  const { t } = useTranslation();
  const { completeSocialLogin } = useAuthContext();

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      // Recupera le informazioni del profilo utente da Google
      const userInfoResponse = await fetch(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        }
      );

      const userInfo = await userInfoResponse.json();
      const email = userInfo.email;

      const userData = await login(
        {
          googleToken: tokenResponse.access_token,
          redirect: String(import.meta.env.VITE_DASHBOARD_REDERICT),
          referralCode,
        },
        true
      );

      if (mode === "register") {
        await cosent({
          email: email,
          target: "dashboard-tos-privacy",
          consent: true,
        });
      }

      completeSocialLogin(userData);
    },
    scope: "email profile",
  });

  return (
    <div
      onClick={() => {
        googleLogin();
      }}
      className="flex gap-3 mt-7 py-2 px-5 border cursor-pointer rounded text-gray-700 dark:text-gray-300 items-center justify-center"
    >
      <img src={googleSvg} alt="google icon" className="h-6" />
      {mode === "login" ? (
        <span className="text-center bodytext regular">
          {t("auth.logingoogle")}
        </span>
      ) : null}
      {mode === "register" ? (
        <span className="text-center bodytext regular">
          {t("auth.registergoogle")}
        </span>
      ) : null}
    </div>
  );
}
